import { useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";

export const TiltCard = ({ children, className = "", testId }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const [style, setStyle] = useState({});
  const [glare, setGlare] = useState({});

  const onMove = (e) => {
    if (reduce || !ref.current || e.pointerType === "touch") return;
    const rect = ref.current.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    setStyle({
      transform: `perspective(900px) rotateY(${px * -10}deg) rotateX(${py * 10}deg) translateZ(6px)`,
      transition: "transform 0.08s linear",
    });
    setGlare({
      background: `radial-gradient(circle at ${(px + 0.5) * 100}% ${(py + 0.5) * 100}%, rgba(226,232,240,0.12), transparent 55%)`,
    });
  };

  const onLeave = () => {
    setStyle({
      transform: "perspective(900px) rotateY(0deg) rotateX(0deg)",
      transition: "transform 0.5s cubic-bezier(0.22,1,0.36,1)",
    });
    setGlare({});
  };

  return (
    <div
      ref={ref}
      data-testid={testId}
      onPointerMove={onMove}
      onPointerLeave={onLeave}
      style={{ ...style, transformStyle: "preserve-3d", willChange: "transform" }}
      className={`relative ${className}`}
    >
      <div className="absolute inset-0 rounded-[inherit] pointer-events-none z-10" style={glare} />
      {children}
    </div>
  );
};
